import { Box, CardMedia, Grid, Typography } from '@mui/material';
import React from 'react';
import { useParams } from 'react-router-dom';

const UseCaseDetails = () => {
    const { id } = useParams();
    const [useCase, setUseCase] = React.useState([]);

    React.useEffect(() => {
        fetch(`../usecase.json`)
            .then(res => res.json())
            .then(data => setUseCase(data));
    }, [])
    const cases = useCase.filter(Case => (Case.id == id))

    const handelBack = e => {
        e.preventDefault()
        window.history.back()
    }

    return (
        <div>
            {cases.map(Case =>
                <Box key={Case.id} sx={{ mx: { xs: 1.2, sm: 3.5, md: 6, lg: 9, xl: 28 } }}>
                    <Typography sx={{ fontFamily: 'poppins', fontWeight: 600, fontSize: { xs: '20px', sm: '23.3px', md: '26.7px', lg: '30px' }, lineHeight: { xs: '30px', sm: '35px', md: '40px', lg: '45px' }, color: '#433ED1', textAlign: 'left', display: { xs: 'none', sm: 'flex' }, alignItems: 'center', mt: '15px' }}><i onClick={handelBack} style={{ marginRight: '18px' }} className="fas fa-solid fa-arrow-left"></i> {Case.title}</Typography>

                    <Box sx={{ display: { xs: 'flex', sm: 'none' }, alignItems: 'center', mt: '12px' }}>
                        <i onClick={handelBack} style={{ marginRight: '14px' }} className="fas fa-solid fa-arrow-left"></i>
                        <CardMedia
                            component="img"
                            sx={{ width: '22px', mr: '12px' }}
                            image="https://i.ibb.co/8dBKgsn/timeline.png"
                            alt="logo"
                        />
                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 600, fontSize: { xs: '20px', sm: '23.3px', md: '26.7px', lg: '30px' }, lineHeight: { xs: '30px', sm: '35px', md: '40px', lg: '45px' }, color: '#433ED1', textAlign: 'left' }}>{Case.title}</Typography>
                    </Box>

                    <CardMedia
                        component="img"
                        sx={{ my: { xs: '25px', md: '30px', lg: '35px' } }}
                        image={Case.top_img}
                        alt="logo"
                    />

                    {/* details */}
                    <Box sx={{ pt: { sm: '50px', md: '70px', xl: '90px' }, pb: { xs: '50px', md: '70px', xl: '90px' }, pl: { sm: '17px', md: '27px', lg: '50px', xl: '70px' }, pr: { xl: '70px' } }}>
                        <Grid container>
                            {/* small top image */}
                            <Grid item xs={12} sm={6} sx={{ display: { sm: 'none' } }}>
                                <CardMedia
                                    component="img"
                                    sx={{ my: '25px', width: '80%', mx: 'auto' }}
                                    image={Case.bottom_img}
                                    alt="logo"
                                />
                            </Grid>
                            {/* large device */}
                            <Grid item xs={12} sm={6} sx={{ display: 'flex', alignItems: 'center' }}>
                                <Typography sx={{ fontFamily: 'poppins', fontWeight: 400, fontSize: { xs: '16px', md: '18px' }, lineHeight: { xs: '30px', sm: '35px', md: '40px', lg: '50px' }, color: '#383838', textAlign: 'left' }}>{Case.details_top}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6} sx={{ display: { xs: 'none', sm: 'inline' } }}>
                                <CardMedia
                                    component="img"
                                    sx={{ my: { sm: '25px', md: '30px', lg: '35px' }, width: { sm: '300px', md: '338px' }, mx: 'auto' }}
                                    image={Case.bottom_img}
                                    alt="logo"
                                />
                            </Grid>
                        </Grid>
                        {/* bottom details */}
                        <Typography sx={{ fontFamily: 'poppins', fontWeight: 400, fontSize: { xs: '16px', md: '18px' }, lineHeight: { xs: '30px', sm: '35px', md: '40px', lg: '50px' }, color: '#383838', textAlign: 'left', pt: '10px' }}>{Case.details_bottom}</Typography>
                    </Box>
                </Box >
            )}
        </div >
    );
};

export default UseCaseDetails;